import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  template: `<p style="text-align:center; padding:40px;">Redirecting…</p>`,
})
export class AuthCallbackComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // The OAuth/Keycloak callback flow has been removed.
    // Google Sign-In is now handled client-side via the GIS SDK (see login/register components).
    this.router.navigate(['/auth/login'], { replaceUrl: true });
  }
}
